import { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Eye } from 'lucide-react';
import './carouselmain.css';
import img1 from '../Components/Images/CIJ/cij.png'
import img2 from '../Components/Images/TIJ/tij1.png'
import img3 from '../Components/Images/Laser/laser1.png'
import img4 from '../Components/Images/TTO/tto1.png'
import img5 from '../Components/Images/weighing1.jpg'
import img6 from '../Components/Images/Packaging/packaging1.png'
import img7 from '../Components/Images/antennas/antenna1.png'
import img8 from '../Components/Images/POS/pos1.png'
import img9 from '../Components/Images/Barcode/barcode2.png'
import img10 from '../Components/Images/Retail weighing/weighing1.png'
import img11 from '../Components/Images/Laser/2.png'
import img12 from '../Components/Images/Retail weighing/dib500.png'
import img13 from '../Components/Images/antennas/cross1.png'

// Sample product images as placeholders (will use placeholder API)
const products = [
  {
    id: 1,
    name: "CIJ Printers",
    description: "High-speed continuous inkjet printing solutions",
    category: "Printers",
    image:img1,
    detail:'/cij'
  },
  {
    id: 2,
    name: "TIJ Printers",
    description: "Thermal inkjet technology for crisp coding",
    category: "Printers",
    image:img2,
    detail:'/tij'
  },
  {
    id: 3,
    name: "Laser Printers",
    description: "Next-generation laser systems for high-definition marking",
    category: "Printers", 
    image:img11,
    detail:'/laser'
  },
  {
    id: 4,
    name: "TTO Printers",
    description: "Thermal transfer overprinting for packaging",
    category: "Printers",
    image:img4,
    detail:'/thermal-transfer'
  },
  {
    id: 5,
    name: "Weighing Scales",
    description: "Precision industrial weighing solutions",
    category: "Measurement",
    image:img5,
    detail:'/weighing-scales'
  },
  {
    id: 6,
    name: "Packaging Machines",
    description: "Automated packaging for efficiency",
    category: "Packaging",
    image:img6,
    detail:'/packaging'
  },
  {
    id: 7,
    name: "Anti-theft Systems",
    description: "Advanced security for retail environments",
    category: "Security",
    image:img13,
    detail:'eas-system'
  },
  {
    id: 8,
    name: "Point-Of-Sale",
    description: "Complete POS solutions for retail industry",
    category: "Retail",
    image:img8,
    detail:'/pos'
  },
  {
    id: 9,
    name: "Barcode Solutions",
    description: "End-to-end barcode scanning and printing",
    category: "Identification",
    image:img9,
    detail:'/barcode products'
  },
  {
    id: 10,
    name: "Retail weighing Scale",
    description: "Customer-facing weighing solutions",
    category: "Retail",
    image:img12,
    detail:'retail-scales'
  }
];

const Carouselmain = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [displayCount, setDisplayCount] = useState(4);
  const [isAnimating, setIsAnimating] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);

  // Determine number of items to show based on screen size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 576) setDisplayCount(1);
      else if (window.innerWidth < 768) setDisplayCount(2);
      else if (window.innerWidth < 992) setDisplayCount(3);
      else setDisplayCount(4);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Auto-scroll functionality with pause on hover
  useEffect(() => {
    if (hoveredCard !== null) return; // Pause when hovering
    
    const interval = setInterval(() => {
      handleNext();
    }, 4000);
    
    return () => clearInterval(interval);
  }, [currentIndex, products.length, displayCount, hoveredCard]);

  const handleNext = () => {
    if (currentIndex < products.length - displayCount && !isAnimating) {
      setIsAnimating(true);
      setCurrentIndex(currentIndex + 1);
      setTimeout(() => setIsAnimating(false), 500);
    } else if (currentIndex >= products.length - displayCount && !isAnimating) {
      // Loop back to the beginning
      setIsAnimating(true);
      setCurrentIndex(0);
      setTimeout(() => setIsAnimating(false), 500);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0 && !isAnimating) {
      setIsAnimating(true);
      setCurrentIndex(currentIndex - 1);
      setTimeout(() => setIsAnimating(false), 500);
    } else if (currentIndex === 0 && !isAnimating) {
      // Loop to the end
      setIsAnimating(true);
      setCurrentIndex(products.length - displayCount);
      setTimeout(() => setIsAnimating(false), 500);
    }
  };

  const visibleProducts = products.slice(currentIndex, currentIndex + displayCount);

  return (
    <div className="container py-5">
      <div className="row mb-4">
        <div className="col-md-6">
          <h2 className="fw-bold text-3xl position-relative mb-3">
            Featured Products
            <span className="position-absolute bottom-0 start-0 w-24 h-1 bg-cyan-600" style={{
              height: '4px',
              width: '80px',
              display: 'block',
              marginTop: '8px'
            }}></span>
          </h2>
        </div>
        <div className="col-md-6 d-flex justify-content-md-end align-items-center">
          <div className="carousel-nav d-flex gap-2">
            <button 
              onClick={handlePrev}
              className="btn btn-nav1 shadow-sm rounded-circle d-flex align-items-center justify-content-center"
              style={{
                width: '40px',
                height: '40px',
                background: 'white',
                border: '1px solid #eee',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#e6f7f9';
                e.currentTarget.style.borderColor = '#00a7ba';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'white';
                e.currentTarget.style.borderColor = '#eee';
              }}
            >
              <ChevronLeft className="text-cyan-600" size={20} />
            </button>
            <button 
              onClick={handleNext}
              className="btn btn-nav1 shadow-sm rounded-circle d-flex align-items-center justify-content-center"
              style={{
                width: '40px',
                height: '40px',
                background: 'white',
                border: '1px solid #eee',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#e6f7f9';
                e.currentTarget.style.borderColor = '#00a7ba';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'white';
                e.currentTarget.style.borderColor = '#eee';
              }}
            >
              <ChevronRight className="text-cyan-600" size={20} />
            </button>
          </div>
        </div>
      </div>

      <div className="product-carousel-container1 overflow-hidden">
        <div 
          className="row flex-nowrap" 
          style={{ 
            transform: `translateX(-${currentIndex * (100 / displayCount)}%)`,
            transition: 'transform 0.5s ease-in-out',
          }}
        >
          {products.map((product) => (
            <div 
              key={product.id} 
              className={`col-${12/displayCount} px-3`}
              style={{ minWidth: `${100 / displayCount}%` }}
              onMouseEnter={() => setHoveredCard(product.id)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div 
                className="card border-0 shadow-sm rounded-3 mb-4 h-100" 
                style={{ 
                  transform: hoveredCard === product.id ? 'translateY(-10px)' : 'translateY(0)',
                  transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                  boxShadow: hoveredCard === product.id ? '0 15px 30px rgba(0,0,0,0.1)' : '0 5px 15px rgba(0,0,0,0.05)'
                }}
              >
                <div className="position-relative">
                  <div className="badge bg-cyan-600 position-absolute top-0 end-0 m-3 fw-normal">
                    {product.category}
                  </div>
                  <img 
                    src={product.image} 
                    className="card-img-top p-4" 
                    alt={product.name}
                    style={{ height: '220px', objectFit: 'contain' }}
                  />
                </div>
                <div className="card-body pt-0 pb-4 px-4">
                  <h5 className="mb-2 fw-bold">{product.name}</h5>
                  <p className="card-text text-muted small mb-4" style={{fontFamily:"sans-serif"}}>{product.description}</p>
                  
                
                    <div 
                    className="view-details d-flex align-items-center"
                    style={{ 
                      opacity: hoveredCard === product.id ? 1 : 0.7,
                      transition: 'all 0.3s ease'
                    }}
                  >
                    <a 
                      href={product.detail} 
                      className="btn text-cyan-600 fw-bold p-0 d-flex align-items-center text-decoration-none"
                      style={{ fontSize: '15px' }}
                      onClick={(e) => {
                        // You can add custom click handling here if needed
                        // e.preventDefault();
                        // console.log(`Navigating to product ${product.id}`);
                        // history.push(`/product/${product.id}`); // If using React Router
                      }}
                    >
                      View Details
                      <span 
                        className="ms-2 d-flex align-items-center justify-content-center"
                        style={{ 
                          transform: hoveredCard === product.id ? 'translateX(5px)' : 'translateX(0)',
                          transition: 'transform 0.3s ease'
                        }}
                      >
                        <Eye size={16} className="text-cyan-600" />
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Progress bar indicator */}
      <div className="progress mt-4 mx-auto" style={{ height: '4px', maxWidth: '200px' }}>
        <div 
          className="progress-bar1 bg-cyan-600" 
          role="progressbar" 
          style={{ 
            width: `${(currentIndex / (products.length - displayCount)) * 100}%`,
            transition: 'width 0.5s ease-in-out'
          }} 
          aria-valuenow={(currentIndex / (products.length - displayCount)) * 100}
          aria-valuemin="0" 
          aria-valuemax="100"
        ></div>
      </div>
    </div>
  );
};

export default Carouselmain;